import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ChainNoticeOutput, ChainNoticesService } from 'core/http/project/courier/chain-notices.service';
import { Observable } from 'rxjs';

@Injectable()
export class NoticeResolver {
  constructor(private chainNoticesService: ChainNoticesService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ChainNoticeOutput> {
    const noticeId = route.params.noticeId;
    const chainId = route.params.courierChainId;

    return this.chainNoticesService.getChainNotice(chainId, noticeId);
  }
}
